export const useHeaderStyles = () => ({
  subCategoriesContainer: {
    paddingBottom: 20,
    justifyContent: 'space-between'
  }
});
